import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper';
import { Link } from 'react-router-dom';

import { sanitizeImageUrl } from 'utils';
import { useLocale } from 'locale';
import { useDataContext } from 'context/data-context';
import { Featured, SlideContent, Detail, Progress } from './styled';

const SLIDE_GAP = 30;
const SLIDE_DURATION_SEC = 3;

export const FeaturedSlider = () => {
  const locale = useLocale();
  const { people } = useDataContext();
  const [isPaused, setIsPaused] = useState(false);
  const [slideIndex, setSlideIndex] = useState(-1);

  return (
    <Featured slideGap={SLIDE_GAP} slideDuration={SLIDE_DURATION_SEC}>
      <Swiper
        onAutoplayPause={() => setIsPaused(true)}
        onAutoplayResume={() => setIsPaused(false)}
        slidesPerView="auto"
        centeredSlides
        pagination={{
          clickable: true,
        }}
        onSlideChange={(swiper) => setSlideIndex(swiper.activeIndex)}
        spaceBetween={SLIDE_GAP}
        modules={[Autoplay, Pagination, Navigation]}
        autoplay={{
          delay: SLIDE_DURATION_SEC * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        speed={500}
        navigation
        draggable
        loop
      >
        {/*people
          .filter(p => p.Featured === 'yes')
          .map(p => (
            <SwiperSlide key={p.id}>
              <SlideContent>
                <img
                  src={sanitizeImageUrl(p.Photo_for_featured, 500)}
                  alt={p.Title_for_featured}
                />
                <Detail>
                  <h3>{p.Title_for_featured}</h3>
                  <p>{p.Subtitle_for_featured}</p>
                  <Link to={`/detail/${p.id}`}>{locale.home.detailButton}</Link>
                </Detail>
              </SlideContent>
            </SwiperSlide>
          ))*/}
        <SwiperSlide>
          <SlideContent>
            <img
              src={sanitizeImageUrl(people[8].Photo_URL, 500)}
              alt={people[8].Name + ' ' + people[8].Surname}
            />
            <Detail>
              <h3>{people[8].Name + ' ' + people[8].Surname}</h3>
              <p>
                Термизлик видеоблогер Отабек Саттторий воқеасини президент Мирзиёевнинг “Янги
                Ўзбекистон”ида блогерлар овозини ўчириш ва сўз эркинлиги бўғилишига яққол мисол
                тарзида келтириш мумкин.
              </p>
              <Link to={`/detail/${8}`}>{locale.home.detailButton}</Link>
            </Detail>
          </SlideContent>
        </SwiperSlide>
        <SwiperSlide>
          <SlideContent>
            <img
              src={sanitizeImageUrl(people[38].Photo_URL, 500)}
              alt={people[38].Name + ' ' + people[38].Surname}
            />
            <Detail>
              <h3>{people[38].Name + ' ' + people[38].Surname}</h3>
              <p>
                2024 йилнинг февраль куни фарғоналик блогер Гули (Гулноз) Мирзаева Қашқадарё вилояти
                Муборак тумани ИИБ томонидан ҳибсга олинган.
              </p>
              <Link to={`/detail/${38}`}>{locale.home.detailButton}</Link>
            </Detail>
          </SlideContent>
        </SwiperSlide>
        <SwiperSlide>
          <SlideContent>
            <img
              src={sanitizeImageUrl(people[3].Photo_URL, 500)}
              alt={people[3].Name + ' ' + people[3].Surname}
            />
            <Detail>
              <h3>{people[3].Name + ' ' + people[3].Surname}</h3>
              <p>
                Мирзиёев танқидчиси сифатида танилган блогер Абдуқодир Мўминовга 2023 йилнинг 4
                август куни жиноят ишлари бўйича Миробод туман суди ҳукми билан 3 йилгача
                журналистлик фаолиятни чеклаш ҳамда 7 йилу 3 ой муддатга озодликдан маҳрум этиш
                жазоси тайинланган.
              </p>
              <Link to={`/detail/${3}`}>{locale.home.detailButton}</Link>
            </Detail>
          </SlideContent>
        </SwiperSlide>
        <SwiperSlide>
          <SlideContent>
            <img
              src={sanitizeImageUrl(people[2].Photo_URL, 500)}
              alt={people[2].Name + ' ' + people[2].Surname}
            />
            <Detail>
              <h3>{people[2].Name + ' ' + people[2].Surname}</h3>
              <p>
                2023 йил декабрида тармоқлардаги тахаллуси “Эмине Караманова” бўлган 47 яшар Лемара
                Мирзааҳмедова 7,5 йилга қамалган.
              </p>
              <Link to={`/detail/${1}`}>{locale.home.detailButton}</Link>
            </Detail>
          </SlideContent>
        </SwiperSlide>
        <SwiperSlide>
          <SlideContent>
            <img
              src={sanitizeImageUrl(people[0].Photo_URL, 500)}
              alt={people[0].Name + ' ' + people[0].Surname}
            />
            <Detail>
              <h3>{people[0].Name + ' ' + people[0].Surname}</h3>
              <p>
                2023 йилнинг 1 декабрь куни Жиноят ишлари бўйича Фарғона туман суди таниқли блогер
                Олимжон Ҳайдаровни 8 йилга озодликдан маҳрум қилиш тўғрисида ҳукм чиқарган.
              </p>
              <Link to={`/detail/${0}`}>{locale.home.detailButton}</Link>
            </Detail>
          </SlideContent>
        </SwiperSlide>
        <SwiperSlide>
          <SlideContent>
            <img
              src={sanitizeImageUrl(people[23].Photo_URL, 500)}
              alt={people[23].Name + ' ' + people[23].Surname}
            />
            <Detail>
              <h3>{people[23].Name + ' ' + people[23].Surname}</h3>
              <p>
                Президент Шавкат Мирзиёев ҳамда оиласини непотизм ҳамда коррупцияда айблаган
                тошкентлик 60 яшар блогер Шоҳида Саломова 2022 йилнинг 18 декабрь куни аввалига
                ғойиб бўлган, сўнгра ҳибсга олинган.
              </p>
              <Link to={`/detail/${23}`}>{locale.home.detailButton}</Link>
            </Detail>
          </SlideContent>
        </SwiperSlide>
      </Swiper>

      <Progress key={slideIndex.toString()} isPaused={isPaused} />
    </Featured>
  );
};
